"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const googleMapsGetPathCoordinatesFromApiResponse_1 = __importDefault(require("./googleMapsGetPathCoordinatesFromApiResponse"));
let cachedResults = {};
const googleMapsGetRoute = async ({ destination, googleApiKey, origin, }) => {
    const originString = `${origin.latitude},${origin.longitude}`;
    const destinationString = `${destination.latitude},${destination.longitude}`;
    const resultKey = `${originString},${destinationString}`;
    if (cachedResults[resultKey]) {
        return cachedResults[resultKey];
    }
    try {
        const response = await axios_1.default.get(`https://maps.googleapis.com/maps/api/directions/json?origin=${originString}&destination=${destinationString}&key=${googleApiKey}`);
        const data = (0, googleMapsGetPathCoordinatesFromApiResponse_1.default)(response.data);
        const chacheEntries = Object.entries(cachedResults);
        if (chacheEntries.length > 50) {
            cachedResults = chacheEntries.splice(0, 10).reduce((newCache, [key, value]) => (Object.assign(Object.assign({}, newCache), { [key]: value })), {});
        }
        cachedResults[resultKey] = data;
        return data;
    }
    catch (error) {
        return [];
    }
};
exports.default = googleMapsGetRoute;
